<template>
    <div class="label-box-container" :class="[$mq, 'col-' + source.columns, { 'no-images': !showImages }]">
        <template v-if="source">
            <!-- Listado timerproduct: misma interacción que timer.vue (v-longpress / v-press) -->
            <template v-if="supportsProductMultiSelect">
                <ProductLabelCard
                    v-for="label in source.items"
                    :key="label.id"
                    :label="label"
                    :index="index"
                    :showCategoryColor="!!source.show_cat"
                    :categoryColor="source.show_cat && categories[label.category_id] ? categories[label.category_id].color : 'transparent'"
                    :states="statesProduct(label.id) || []"
                    :selected="isProductSelected(label)"
                    :isMultiSelectMode="isMultiSelectMode"
                    :hasTimer="hasTimer(label)"
                    :showImages="showImages"
                    @select="select"
                    @long-press="handleLongPress"
                    @toggle-select="handleToggleSelect"
                />
            </template>
            <!-- Label / resto: click simple sin alterar el flujo existente -->
            <template v-else>
                <div v-for="label in source.items" :key="label.id" class="label" :class="{ 'no-images': !showImages }" @click="select(label)">
                    <span
                        class="color"
                        v-if="source.show_cat"
                        v-bind:style="{
                            backgroundColor: categories[label.category_id].color
                        }"
                    ></span>
                    <i v-if="hasTimer(label)" class="i-andy-menu-timer timer-indicator" aria-hidden="true"></i>
                    <div v-if="showImages && !isApp" class="image">
                        <img :src="label.image ? label.image : appURL + 'img/offline/no_icon_light.svg'" :alt="formatDisplayMeasurement(label.name || '')" />
                    </div>
                    <div
                        v-else-if="showImages"
                        class="imageapp"
                        :class="{ appempty: !label.local_image && !label.image }"
                        :style="{
                            backgroundImage: 'url(' + (label.local_image ? label.local_image : label.image) + ')'
                        }"
                    ></div>
                    <div class="label-text">
                        <span class="label-text__name">{{ formatDisplayMeasurement(label.name) }}</span>
                    </div>
                    <div v-if="type == 'timerproduct'" class="meta">
                        <div class="column" v-for="state in statesProduct(label.id)" :key="state.id || state.status" :class="['status-' + state.status]"></div>
                    </div>
                </div>
            </template>
        </template>
        <p v-if="!source" class="empty">
            {{ $t('label.empty_labels') }}
        </p>
    </div>
</template>

<script>
import { formatMeasurementLabel } from '@/utils/numberFormat'

import ProductLabelCard from '@/components/domain/label/ProductLabelCard.vue'

export default {
    name: 'LabelItem',
    components: {
        ProductLabelCard
    },
    props: {
        index: {
            type: Number
        },
        source: {
            type: Object,
            default() {
                return {}
            }
        },
        label: {
            type: undefined,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        },
        showBall: {
            type: undefined,
            default: false
        },
        type: {
            type: String,
            default: 'label'
        },
        isMultiSelectMode: {
            type: Boolean,
            default: false
        },
        selectedProductIds: {
            type: Object,
            default() {
                return {}
            }
        },
        onActivateMultiSelect: {
            type: Function,
            default: null
        },
        onToggleProductSelect: {
            type: Function,
            default: null
        },
        /**
         * BUILD-7687: oculta miniaturas si la vista del board lo pide.
         * Default true para no afectar Label ni otros usos.
         */
        showImages: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        categories() {
            return this.$store.getters[this.type + '/getCategories']
        },
        appURL() {
            return process.env.VUE_APP_APP_URL
        },
        isApp() {
            return process.env.VUE_APP_IS_APP == 'TRUE'
        },
        supportsProductMultiSelect() {
            return this.type === 'timerproduct' && typeof this.onActivateMultiSelect === 'function' && typeof this.onToggleProductSelect === 'function'
        }
    },
    methods: {
        formatDisplayMeasurement(value) {
            return formatMeasurementLabel(value, this.$i18n.locale, count => this.$tc('measurements.unit', count))
        },
        select(label) {
            label.index = this.index
            this.$root.$emit('label', label)
        },
        statesProduct(reference_id) {
            return this.type == 'timerproduct' ? this.$store.getters['timerproduct/getTimersByStateAndProduct'](reference_id) : false
        },
        hasTimer(label) {
            if (this.type !== 'timerproduct') {
                return false
            }
            const states = this.statesProduct(label.id)
            if (!states) {
                return false
            }
            return states.some((state) => Number(state.status) !== -1)
        },
        isProductSelected(label) {
            if (!label || !this.supportsProductMultiSelect) {
                return false
            }
            return !!this.selectedProductIds[label.id]
        },
        handleLongPress(label) {
            if (!this.supportsProductMultiSelect) {
                return
            }
            this.onActivateMultiSelect(label)
        },
        handleToggleSelect(label) {
            if (!this.supportsProductMultiSelect) {
                return
            }
            this.onToggleProductSelect(label)
        }
    }
}
</script>

<style lang="scss" scoped>
$icon-size: rem(60px);

.label-box-container {
    width: 100%;
    height: 100%;
    max-height: 145px;
    min-height: 145px;

    /**
     * BUILD-7687: sin foto la fila solo necesita nombre + barra.
     * El estimate-size del virtual-list se alinea en products.vue.
     */
    &.no-images {
        max-height: 76px;
        min-height: 76px;
    }

    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;

    &.col-5 {
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    &.col-4 {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    &.col-3 {
        grid-template-columns: 1fr 1fr 1fr;
    }
    &.col-2 {
        grid-template-columns: 1fr 1fr;
    }
    &.col-1 {
        grid-template-columns: 1fr;
    }

    .label {
        @include border-radius(5px);
        @include display-flex();
        @include flex-direction(column);
        background-color: #fff;
        width: 100%;
        height: 100%;
        padding: 5px;
        position: relative;
        cursor: pointer;
        overflow: hidden;

        .color {
            @include border-radius(10px);
            width: 18px;
            height: 18px;
            position: absolute;
            top: 5px;
            left: 5px;
        }

        .timer-indicator {
            position: absolute;
            top: 5px;
            right: 5px;
            font-size: 20px;
            line-height: 1;
            color: $color-neutral-400;
            z-index: 2;
            pointer-events: none;
        }

        .image {
            display: block;
            margin: 10px auto;
            text-align: center;
            height: 60%;
            margin-top: 3px;
            padding: 15px;
            min-height: 0;
            overflow: hidden;
            flex-shrink: 1;

            img {
                height: 100%;
                object-fit: contain;
            }
        }

        .label-text {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            width: 100%;
            height: 30%;
            max-height: 30%;
            min-height: 0;
            flex-shrink: 0;
            overflow: hidden;
            box-sizing: border-box;

            &__name {
                @include font-size(sm);
                @include text-ellipsis($line: 2);
                font-family: $text-bold;
                text-align: center;
                color: $main-s90;
                // line-height < font-size recortaba glifos y dejaba restos de la 3ª línea
                line-height: 1.2;
                max-height: 2.4em;
                max-width: 100%;
                word-break: break-word;
                overflow-wrap: break-word;
                text-overflow: ellipsis;
            }
        }
        .imageapp {
            @include background($image: img('offline/no_icon_light.svg'));
            display: block;
            margin: 10px auto;
            text-align: center;
            height: 60%;
            margin-top: 3px;
            padding: 15px;
            width: 60%;
            min-height: 0;
            overflow: hidden;
            flex-shrink: 1;
            img {
                height: 100%;
                object-fit: contain;
            }

            &.appempty {
                @include background($image: img('offline/no_icon_light.svg') !important);
            }
        }

        &.no-images {
            padding: 8px 6px 5px;

            .label-text {
                flex: 1 1 auto;
                height: auto;
                max-height: none;
            }
        }

        .meta {
            width: 100%;
            height: 7px;
            min-height: 7px;
            flex-shrink: 0;
            display: flex;
            border-radius: 1px;
            margin-top: auto;

            .column {
                content: ' ';
                flex: 1;
                margin: 0 2px;

                &.status--1 {
                    background-color: $color-neutral-300 !important;
                }
                &.status-0 {
                    background-color: $color-error-500 !important;
                }
                &.status-1 {
                    background-color: $color-secondary-500 !important;
                }
                &.status-2 {
                    background-color: $done !important;
                }
                &.status-3 {
                    background-color: $color-warning-500 !important;
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.label-box-container.portrait {
    .label-text__name {
        @include font-size(s);
        line-height: 1.2;
    }
}
</style>
